import { z } from "zod";
import { getBlockConfig } from "../constants";
import { ContactDetailsBlockInfoRegistry, ContactDetailsBlockType } from "../types";

export const parseBlockInfo = <T extends ContactDetailsBlockType>(
  type: T,
  info: unknown
): ContactDetailsBlockInfoRegistry[T] | undefined => {
  const config: { infoSchema?: z.ZodType<ContactDetailsBlockInfoRegistry[T]> } = getBlockConfig(type);
  if (!config.infoSchema) return undefined;

  const result = config.infoSchema.safeParse(info);
  if (!result.success) return undefined;

  return result.data;
};
